import { type PropsWithChildren } from 'react';

import { twMerge } from 'tailwind-merge';

import { Avatar, AvatarFallback, AvatarImage, Tooltip } from '@/_components';

export function SelectorWithAvatarContainer({
  src,
  label,
  name,
  children,
  className,
  avatarClassName,
  disabled,
  avatarContainerClassName = '',
}: PropsWithChildren<{
  disabled?: boolean;
  avatarContainerClassName?: string;
  src: string;
  label: string;
  name: string;
  className?: string;
  avatarClassName?: string;
}>) {
  return (
    <section
      className={twMerge(
        'col-span-12 flex flex-1 items-start justify-between select-none sm:col-span-6 sm:gap-y-2 md:col-span-12 lg:col-span-6 lg:flex-col lg:items-start 2xl:col-span-3',
        className
      )}
    >
      <div
        className={twMerge(
          `border-c-border mb-px h-11 border-b pr-2.5 pb-2`,
          disabled && 'border-c-border-muted',
          avatarContainerClassName
        )}
      >
        <Tooltip content={label}>
          <Avatar size="lg" className={twMerge('-mt-2', avatarClassName)}>
            <AvatarImage src={src} className="object-contain" />
            <AvatarFallback name={name || label} className="text-xs" />
          </Avatar>
        </Tooltip>
      </div>

      <div className="mb-0 w-full sm:mb-0">{children}</div>
    </section>
  );
}
